import { Component } from '@angular/core';

import { LayoutService } from '../../services/layout.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { TranslationService } from 'src/app/shared/services/translation.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html'
})
export class FooterComponent {
  constructor(
    public layoutService: LayoutService,
    private common_service: CommonService,
    public translate_service:TranslationService
  ) {}

  getver(){
    return this.common_service.getversion();
  }

  getpbw(){
    return this.common_service.getpoweredbyversion();
  }
}
